import CancelModalButton from 'components/Custom/CancelModalButton'
import SubmitModalButton from 'components/Custom/SubmitModalButton'
import React from 'react'
import { useDispatch } from 'react-redux'
import { Card, CardBody, Col, Input, Row } from 'reactstrap'
import { onChange } from 'store/Discussion/actions'
import { createThread } from 'store/Discussion/actions'
import { TextEditor } from 'views/pages/Editor'
import { Link } from 'react-router-dom'

const CreateDiscussion = (props) => {
  let language = {}
  const dispatch = useDispatch()
  // eslint-disable-next-line no-unused-expressions
  props.language.language ? (language = props.language.language.data) : null
  return (
    <div className='d-flex justify-content-center mt--5'>
      <Col xl='10' className='mb-3 '>
        <Card className='p-2'>
          <h3 className='text-center pt-3 pb-3'>Create new comment</h3>
          <CardBody>
            <Row className='justify-content-center'>
              <Col md='7'>
                <Input
                  type='text'
                  placeholder={
                    language.discussions
                      ? language.discussions.title_of_the_topic
                      : null
                  }
                  value={props.title}
                  autoFocus
                  onChange={(event) =>
                    dispatch(onChange('title', event.target.value))
                  }
                  className='mb-3'
                />
              </Col>
              <Col md='7'>
                <div className='discussion-editor-container'>
                  <TextEditor
                    {...props}
                    onChange={'onChangeDiscussion'}
                    placeholder={
                      language.discussions
                        ? language.discussions.description_of_the_topic
                        : null
                    }
                  />
                </div>
              </Col>
              <Col md='7'>
                <Row className='pl-3 align-items-center'>
                  <Link to='/discussions'>
                    <SubmitModalButton
                      text={language.general ? language.general.submit : null}
                      customFn={() => dispatch(createThread())}
                    />
                  </Link>
                  <Link to='/discussions'>
                    <CancelModalButton />
                  </Link>
                </Row>
              </Col>
            </Row>
          </CardBody>
        </Card>
      </Col>
    </div>
  )
}

export default CreateDiscussion
